<template>
  <div class="v-input v-input--switch theme--light" :class="{ 'v-input--is-label-active v-input--is-dirty': value }" @click="$emit('input', !value)">
    <div class="v-input__control">
      <div class="v-input__slot" style="margin: 0">
        <div class="v-input--selection-controls__input">
          <input type="checkbox" value="true" />
          <div class="v-input--switch__track theme--light" :class="{ 'accent--text': value }"></div>
          <div class="v-input--switch__thumb theme--light" :class="{ 'accent--text': value }">
            <!---->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
}
</script>